module.exports = __webpack_public_path__ + "img/register2.d1e2eab8.png";